import { CartButtonToggle } from "./CartButtonToggle";
import { jsx as _jsx } from "react/jsx-runtime";
export function CartButton(props) {
  return /*#__PURE__*/_jsx("div", {
    children: /*#__PURE__*/_jsx(CartButtonToggle, {
      project: props.project,
      isAlreadyInCart: props.isAlreadyInCart,
      removeFromCart: props.removeFromCart,
      addToCart: props.addToCart,
      setCurrentProjectAddedToCart: props.setCurrentProjectAddedToCart,
      setShowCartNotification: props.setShowCartNotification
    })
  });
}